import { useMemo } from 'react';
import styles from './PlanCardTitle.module.scss';
import { PlanKind } from 'src/types';
import { PLAN_KIND_TITLE_MAP_V3 } from 'src/constants';

export interface PlanCardTitleV2Props {
  planKind: PlanKind;
}

export const PlanCardTitle = ({ planKind }: PlanCardTitleV2Props) => {
  const displayName = useMemo(() => {
    return PLAN_KIND_TITLE_MAP_V3[planKind]?.fullTitle || '';
  }, [planKind]);

  return (
    <div>
      <h5 className={styles.title}>{displayName}</h5>
      <p className={styles.subtitle}>
        {PLAN_KIND_TITLE_MAP_V3[planKind]?.description}
      </p>
    </div>
  );
};
